<template>
    <svg
        alt="Pinterest"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M11.989 4.523A7.981 7.981 0 0 0 4 12.512a7.971 7.971 0 0 0 5.082 7.439c-.08-.641-.138-1.603.034-2.3.149-.619.938-3.972.938-3.972s-.263-.47-.263-1.19c0-1.11.641-1.946 1.442-1.946.687 0 1.007.515 1.007 1.122 0 .686-.446 1.705-.652 2.666-.183.79.4 1.442 1.19 1.442 1.42 0 2.507-1.488 2.507-3.65 0-1.912-1.374-3.251-3.33-3.251-2.267 0-3.606 1.705-3.606 3.468 0 .687.263 1.43.595 1.82.057.08.08.148.057.228-.057.264-.194.79-.228.916-.035.149-.126.183-.275.103-.984-.47-1.614-1.934-1.614-3.101 0-2.53 1.82-4.842 5.276-4.842 2.77 0 4.933 1.98 4.933 4.613 0 2.632-1.74 4.978-4.132 4.978-.8 0-1.568-.423-1.82-.915 0 0-.4 1.522-.503 1.9-.183.698-.664 1.567-.984 2.094A7.989 7.989 0 0 0 20 12.5c-.011-4.406-3.594-7.989-8-7.989l-.011.012Z" fill="currentColor"/>
    </svg>
</template>
